<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .contact-activity-tab {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;

    .contact-activity-dropdown {
      position: absolute;
      right: 0;
      top: utils.in_rem(12px);
    }
  }
</style>

<script>
  // Components
  import ContactActivityTable from "../components/ContactActivityTable.svelte";
  import TableSelectDropdown from "../components/TableSelectDropdown.svelte";
  // Stores
  import { activityFeedStore, selectedTableStore } from "../stores";

  const items = [
    { text: "Past Activity", value: "pastActivity" },
    { text: "Scheduled Activity", value: "scheduledActivity" },
  ];
  // Set default selected table as the first element in the items array
  $: $selectedTableStore.contactActivity ??= items[0];

  $: filteredActivityFeed = $activityFeedStore.feed.filter((item) => {
    const selectedView = $selectedTableStore.contactActivity.value;

    return (
      (item.scheduled && selectedView === "scheduledActivity") ||
      (!item.scheduled && selectedView === "pastActivity")
    );
  });
</script>

<div class="contact-activity-tab">
  <div class="contact-activity-dropdown">
    <TableSelectDropdown
      {items}
      size="small"
      selectorStyle="padding-right: 2px;"
      bind:selectedItem={$selectedTableStore.contactActivity}
    />
  </div>
  <ContactActivityTable
    data={filteredActivityFeed}
    selectedView={$selectedTableStore.contactActivity.value}
  />
</div>
